import React from 'react';
import { motion } from 'framer-motion';
export function BrandMoment() {
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center justify-center relative" data-id="element-36">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.0,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-37">
        {/* P Monogram — brand submark */}
        <img src="https://cdn.magicpatterns.com/uploads/19npFbZLmafDuvoq6Wz5Bo/ChatGPT_Image_Apr_30,_2026,_04_05_58_PM.png" alt="Pollock Ventures monogram" className="w-32 h-32 sm:w-40 sm:h-40 md:w-52 md:h-52 object-contain select-none" data-id="element-38" />

        {/* POLLOCK VENTURES wordmark */}
        <img src="https://cdn.magicpatterns.com/uploads/4QnKWqMyoVtYRAEErqpPgC/ChatGPT_Image_Apr_30,_2026,_04_00_28_PM.png" alt="Pollock Ventures" className="w-[180px] sm:w-[220px] md:w-[260px] h-auto select-none -mt-20 sm:-mt-24 md:-mt-28 -mb-14 sm:-mb-16 md:-mb-20" data-id="element-39" />

        {/* Thin gold divider */}
        <div className="w-16 h-px bg-brand-gold/40 mb-8 sm:mb-10" data-id="element-40" />

        {/* Brand essence pillars from brand kit */}
        <p className="font-heading text-[9px] sm:text-[10px] tracking-[0.3em] text-brand-warmGrey/70 uppercase text-center mb-6 sm:mb-8" data-id="element-41">
          Professional · Futuristic · Timeless · Built for what's next
        </p>

        <p className="font-heading text-[10px] sm:text-xs tracking-widest text-brand-warmGrey/40 uppercase" data-id="element-42">
          © 2026 Pollock Ventures
        </p>
      </motion.div>
    </section>;
}